import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractService } from '../commons/abstract.service';
import { CampaignFailureSummary, CampaignMessage, CampaignMessageAnalytics, CampaignMessageLatency, CampaignProgressSnapshot } from '../models/campaign-message.model';

@Injectable({ providedIn: 'root' })
export class CampaignMessageService extends AbstractService<CampaignMessage> {

  getURLBase(): string {
    return '/campaign-message';
  }

  constructor(private http: HttpClient) {
    super(http);
  }

  preCreate(campaignSendMessage: CampaignMessage): void {
    delete campaignSendMessage._id;
  }

  preUpdate(campaignSendMessage: CampaignMessage): void {
  }

  getCampaignAnalytics(idCampaign: string): Observable<CampaignMessageAnalytics> {
    return super.get(`/analytics/${idCampaign}`);
  }

  getCampaignLatency(idCampaign: string): Observable<CampaignMessageLatency> {
    return super.get(`/latency/${idCampaign}`);
  }

  getCampaignProgress(idCampaign: string): Observable<CampaignProgressSnapshot> {
    return super.get(`/progress/${idCampaign}`);
  }

  /**
   * As falhas de vários disparos de uma vez — uma chamada por página da lista,
   * não uma por linha.
   *
   * Só volta quem tem falha, então a resposta é normalmente vazia. Quem chama
   * trata ausência como zero.
   */
  getCampaignFailures(idCampaigns: Array<string>): Observable<Array<CampaignFailureSummary>> {
    return super.getWithParams('/failures/by-campaign', { campaigns: idCampaigns.join(',') });
  }


}
